function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.7634,
    height: 26.7634,
    viewBox: "0 0 26.7634 26.7634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3817,0h0c0,7.3905-5.9912,13.3817-13.3817,13.3817h0c7.3905,0,13.3817,5.9912,13.3817,13.3817h0c0-7.3905,5.9912-13.3817,13.3817-13.3817h0c-7.3905,0-13.3817-5.9912-13.3817-13.3817Z",
    style: {
      fill: "#ffffff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/Sparkle.95b354a10da0643d60e13e63c0d2f68d.svg";
export { ForwardRef as ReactComponent };